var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "rbSelectWrapper" }, [
    _c("input", {
      staticClass: "rbSelect",
      attrs: { readonly: "readonly" },
      domProps: { value: _vm.selected.label },
      on: {
        click: function ($event) {
          return _vm.toggleOptions()
        },
        blur: function ($event) {
          return _vm.hideOptions()
        },
        focus: function ($event) {
          return _vm.unselectInputText($event)
        },
        keydown: function ($event) {
          return _vm.handleKeyDown($event)
        },
      },
    }),
    _c("div", { staticClass: "rbSelectArrow", class: _vm.arrowClasses }),
    _vm.opened
      ? _c(
          "ul",
          { staticClass: "rbOptions" },
          _vm._l(_vm.options, function (option, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "rbOption",
                class: { highlighted: _vm.preselectedInList === index },
                on: {
                  mousemove: function ($event) {
                    _vm.preselectedInList = index
                  },
                  mousedown: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.select(index, $event)
                  },
                },
              },
              [_vm._v(" " + _vm._s(option.label) + " ")]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }